(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["animations"] && !Shopify.designMode) return;
  try {
    // Shared, ref-counted scroll lock so multiple overlays (menu drawer, cart drawer) can't
  // clobber each other's body-overflow reset — closing one no longer unlocks the page while
  // another is still open.
  if (!window.MetryScrollLock) {
    window.MetryScrollLock = (function () {
      var count = 0;
      return {
        lock: function () { count++; document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; },
        unlock: function () { count = Math.max(0, count - 1); if (count === 0) { document.documentElement.style.overflow = ''; document.body.style.overflow = ''; } }
      };
    })();
  }

  (function () {
    var root = document.documentElement;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll() {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('reveal-in');
      });
    }

    function initReveal() {
      var els = document.querySelectorAll('[data-reveal]');
      if (reduce || !('IntersectionObserver' in window)) {
        revealAll();
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      els.forEach(function (el) { io.observe(el); });
    }

    function initImageFade() {
      document.querySelectorAll('img.lazy-fade').forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) {
          img.classList.add('is-loaded');
        } else {
          img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
          img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
        }
      });
    }

    function start() { initReveal(); initImageFade(); }

    window.MetryReveal = {
      init: initReveal,
      revealAll: revealAll,
      initImageFade: initImageFade
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-styles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-code')) {
    customElements.define('gift-code', class extends HTMLElement {
      connectedCallback() {
        const b = this.querySelector('[data-code]');
        if (b) b.addEventListener('click', () => {
          if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.code);
          b.classList.add('is-copied'); setTimeout(() => b.classList.remove('is-copied'), 1500);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mt-featured-product-card"] && !Shopify.designMode) return;
  try {
    class MtProductActions extends HTMLElement {
    connectedCallback() {
      this.wishlistButton = this.querySelector('[data-wishlist]');
      this.addButton = this.querySelector('[data-add-to-cart]');
      this.status = this.querySelector('[data-status]');
      if (this.wishlistButton) {
        this.restoreWishlist();
        this.wishlistButton.addEventListener('click', () => this.toggleWishlist());
      }
      if (this.addButton) this.addButton.addEventListener('click', () => this.addToCart());
    }

    getWishlist() {
      try {
        return JSON.parse(localStorage.getItem('mt-wishlist') || '[]');
      } catch (error) {
        return [];
      }
    }

    restoreWishlist() {
      this.setWishlistState(this.getWishlist().includes(this.dataset.productId));
    }

    toggleWishlist() {
      const wishlist = this.getWishlist();
      const index = wishlist.indexOf(this.dataset.productId);
      if (index >= 0) wishlist.splice(index, 1);
      else wishlist.push(this.dataset.productId);
      localStorage.setItem('mt-wishlist', JSON.stringify(wishlist));
      this.setWishlistState(index < 0);
      document.dispatchEvent(
        new CustomEvent('wishlist:changed', {
          detail: { productId: this.dataset.productId, active: index < 0 },
        })
      );
    }

    setWishlistState(active) {
      this.wishlistButton.setAttribute('aria-pressed', String(active));
      this.wishlistButton.classList.toggle('is-active', active);
    }

    async addToCart() {
      this.addButton.disabled = true;
      try {
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: this.addButton.dataset.variantId, quantity: 1 }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to add item');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product' } }));
        this.showStatus(this.addButton.dataset.addedText, false);
      } catch (error) {
        this.showStatus(error.message, true);
      } finally {
        this.addButton.disabled = false;
      }
    }

    showStatus(message, isError) {
      if (!this.status) return;
      this.status.textContent = message;
      this.status.classList.toggle('is-error', isError);
    }
  }

  if (!customElements.get('mt-product-actions')) customElements.define('mt-product-actions', MtProductActions);
  } catch(e) { console.error(e); }
})();

})();
